import 'twin.macro';
import React, { useState } from 'react';
import DatePicker, {
  DateRange,
} from '@teetsh/app/src/components/Form/DatePicker';
import { format } from '@teetsh/app/src/utils/time/format';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Dialog from '@teetsh/app/src/components/Dialog';
import { DuplicateIcon } from 'components/Icons/icons/Duplicate';
import differenceInDays from '@teetsh/app/src/utils/time/differenceInDays';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { Infobox } from 'components/Callout/Infobox';

export function DateDialog({
  onClose,
  isOpen,
  onSubmit,
  startSunday,
}: {
  onClose: () => void;
  isOpen: boolean;
  onSubmit: (d: Date[]) => void;
  startSunday?: boolean;
}) {
  const { locale } = useUser();
  const [range, setRange] = useState<DateRange>([null, null]);
  const { t } = useTranslation(['emploiDuTemps', 'common']);
  const hasMoreThan2Weeks =
    range[0] && range[1] ? differenceInDays(range[1], range[0]) > 15 : false;
  const pattern = locale === 'en-US' ? 'EEE MM/dd' : 'EEE dd/MM';
  return (
    <Dialog
      size="md"
      title={t('emploiDuTemps:sidebar.transfertCJDateModal.title')}
      isOpen={isOpen}
      zIndex="40"
      disabledClickOutside={false}
      onClose={onClose}
    >
      <Dialog.Body>
        {!range[0] && !range[1] && (
          <Infobox
            tw="mb-8"
            title={t(
              'emploiDuTemps:sidebar.transfertCJDateModal.selectFirstDate',
            )}
            intent="primary"
          />
        )}
        <div tw="flex justify-center">
          <div tw="p-1">
            <DatePicker
              mode="range"
              userLocale={locale}
              sundayStart={startSunday}
              value={range}
              onChange={setRange as (v: DateRange) => void}
            />
          </div>
        </div>

        {hasMoreThan2Weeks && (
          <Infobox tw="mt-4" intent="warning">
            {t('emploiDuTemps:sidebar.transfertCJDateModal.max2WeeksRange')}
          </Infobox>
        )}
      </Dialog.Body>
      <Dialog.Footer>
        {!range[1] && range[0] && (
          <Infobox
            title={t(
              'emploiDuTemps:sidebar.transfertCJDateModal.selectAndEndDate',
            )}
            intent="primary"
          >
            {t(
              'emploiDuTemps:sidebar.transfertCJDateModal.youCanSelectTheSameDay',
            )}
          </Infobox>
        )}
        {range[0] && range[1] && (
          <>
            <Button minimal onClick={onClose} large>
              {t('common:buttons.cancel')}
            </Button>
            <Button
              large
              onClick={() =>
                onSubmit(range.map(r => (r !== null ? r : new Date())))
              }
              disabled={hasMoreThan2Weeks}
              intent="primary"
              icon={DuplicateIcon as any}
            >
              {t('emploiDuTemps:sidebar.transfertCJDateModal.submitLabel', {
                from: format(range[0], locale, pattern),
                to: format(range[1], locale, pattern),
              })}
            </Button>
          </>
        )}
      </Dialog.Footer>
    </Dialog>
  );
}
